export interface IExplorerUserRow {
  lastSeen: string;
  clientId: string;
  UserId: string;
}
export interface IExplorerUserInfo {
  city: string;
  zipCode: string;
  Platform: string;
}

export interface IExplorerFilter {
  client_id: string;
  user_id: string;
  device_name: string;
  application_version: string;
}

export enum EQueryIdType {
  userId = 'user_id',
  clientId = 'client_id',
  ip = 'ip_type',
}
